export default __webpack_public_path__ + "static/media/loading-animation.73a5bba8.gif";